module.exports = __webpack_public_path__ + "static/img/lh-icon.634e331b.svg";